import type { ShiftChecklist } from "@apartos/contracts";

export type ShiftChecklistKey = Exclude<keyof ShiftChecklist, "extraNotes">;

export const shiftChecklistItems: ReadonlyArray<{ key: ShiftChecklistKey; label: string; accept: string; handover: string }> = [
  { key: "cash", label: "Сверка денег", accept: "Пересчитал(а) наличные вместе с прошлой сменой, сумма совпадает с CRM", handover: "Пересчитал(а) наличные, сумма совпадает с CRM" },
  { key: "checkIns", label: "Заселения", accept: "Проверил(а) заезды на сегодня: кто приедет, оплата, ключ-карты", handover: "Все заселения смены отмечены в CRM, оплаты внесены" },
  { key: "checkOuts", label: "Выезды гостей", accept: "Проверил(а) выезды на сегодня и незакрытые выезды прошлой смены", handover: "Все выезды отмечены, ключ-карты возвращены, апартаменты осмотрены" },
  { key: "cleaning", label: "Уборка", accept: "Проверил(а) уборки: что в работе, что ждёт горничную", handover: "Уборки назначены, статусы в CRM актуальны" },
  { key: "other", label: "Другое", accept: "Прочитал(а) комментарий прошлой смены: просьбы гостей, поломки, поручения", handover: "Просьбы гостей, поломки и поручения записаны в комментарий" },
];

export const emptyShiftChecklist = (): ShiftChecklist => ({ cash: false, checkIns: false, checkOuts: false, cleaning: false, other: false, extraNotes: "" });

export const isShiftChecklistComplete = (checklist: ShiftChecklist) => shiftChecklistItems.every((item) => checklist[item.key]);

export const toShiftChecklistPayload = (checklist: ShiftChecklist): ShiftChecklist => ({
  cash: checklist.cash, checkIns: checklist.checkIns, checkOuts: checklist.checkOuts,
  cleaning: checklist.cleaning, other: checklist.other,
  ...(checklist.extraNotes?.trim() ? { extraNotes: checklist.extraNotes.trim() } : {}),
});
